const Footer = () => {
  return (
    <div className="thi-footer text-center">
      <hr />
      <p className="mb-1"><strong>FOH LAB - Name of Excellence</strong></p>
    </div>
  );
};

export default Footer;
